import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(null);      // actual auth data
    const [authLoaded, setAuthLoaded] = useState(false); // lifecycle flag

    return (
        <AuthContext.Provider value={{ auth, setAuth, authLoaded, setAuthLoaded }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
